
export const EulaStatusTypes = {
    fullyAccepted: 0,
    notAccepted: 1,
    canadaAddendumNeeded: 2,
    canadaAddendumDeferred: 3
}
